import {
  Avatar, AvatarProps, ICON_MICROPHONE_OUTLINE,
} from '@doveit/bricks';
import React from 'react';

export type HRInterviewAvatarProps = Pick<AvatarProps, 'size'>;

export const HRInterviewAvatar: React.FC<HRInterviewAvatarProps> = (props) => (
  <Avatar
    {...props}
    placeholder={ICON_MICROPHONE_OUTLINE}
  />
);

export default HRInterviewAvatar;
